export default "__VITE_ASSET__b9c92542__"